export function convertUnitOfMeasure(
  quantity: string,
  unitOfMeasure: string,
): { quantity: string; unitOfMeasure: string } {
  if (quantity === "1000" && unitOfMeasure === "g") {
    return {
      quantity: "1",
      unitOfMeasure: "kg",
    };
  }

  if (quantity === "1000" && unitOfMeasure === "ml") {
    return {
      quantity: "1",
      unitOfMeasure: "L",
    };
  }

  return {
    quantity,
    unitOfMeasure,
  };
}
